<template>
    <div style="height:100%">
        <div class="complaints_head" :style="{background:'rgba('+rgbaFn(type.color)+',0.5)',padding:'9px'}" v-if="isShow">
            <img :src="dealColorFn(type.type).imgUrl" align="bottom" alt="">
            <div>{{item.bidSectionCode}}</div>
        </div>
        <div class="complaints_cotent" :style="{background:'rgba('+rgbaFn(type.color)+',0.2)',height:isShow?'calc(100% - 36px)':'100%'}" @mouseenter="openBtn" @mouseleave="openBtn">
            <div class="content-title">
                <el-tooltip effect="dark" :content="item.bidSectionName" placement="right">
                    <div class="card_texts">{{item.bidSectionName}}</div>
                </el-tooltip>
            </div>
            <div class="content-flex-row">
                <span><icon-svg name="w"></icon-svg></span>
                <span>预警内容</span>
                <el-tooltip class="tooltipItem" effect="dark" :content="item.warnContent" placement="right">
                    <div>{{item.warnContent}}</div>
                </el-tooltip>
            </div>
            <div class="content-flex-row">
                <span><icon-svg name="rt"></icon-svg></span>
                <span>预警条件</span>
                <span>{{item.warnCondition}}</span>
            </div>
            <div class="content-flex-row">
                <span><icon-svg name="time"></icon-svg></span>
                <span>预警时间</span>
                <span>{{item.warnTime}}</span>
            </div>
            <div v-if="!isShow" class="btnBox">
                <el-button type="primary"  @click="openDetail(item)">查 看</el-button>
                <el-button type="text" @click="dealDetail(item)">忽略</el-button>
            </div>
            <div class="header_img">
                <img src="~@/assets/images/fixed.png" v-if="historyid==-1" alt="">
                <img src="~@/assets/images/status_processed.png" v-if="historyid==0" alt="">
                <img src="~@/assets/images/status_ignore.png" v-if="historyid==1" alt="">
            </div>
        </div>
        <el-dialog title="处理意见" :visible.sync="dialogVisible" width="30%">
            <div class="dialogBox">
                <el-input type="textarea" maxlength="200"  show-word-limit v-model="auditForm.opinion"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handle()"  style="margin-bottom:20px;">确 定</el-button>
                <el-button @click="dialogVisible=false" class="backBtn">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {jzwarnrecordHandle } from "@/server/warnItem";
export default {
    props:{
        item:{
            type:Object,
            default:''
        },
        warnOptions:{
            type:Array,
            default:function(){return []}
        },
        type:{
            type:Object,
            default:''
        },
        historyid:{
            type:Number,
            default:0
        },
    },
    data(){
        return{
            isShow:true,
            dialogVisible:false,
            auditForm:{
                opinion:'',
                historyId:1
            },
            dealId:''
        }
    },
    methods:{
        dealColorFn(type){//处理数据
            var data=this.warnOptions.filter((ele)=>{return ele.type==type})
            return data[0];
        },
        openBtn(){
            this.isShow=!this.isShow
        },
        async openDetail(item){
            // removeTabHandle("early_warning_detail")
            window.open(  '/early_warning/detail?id='+item.id+'&menuItemCode=' + item.menuItemCode);
            // window.opener.postMessage({type:true,url:'early_warning_detail',parent:'busWitness_list',query:{
            //         id:item.id,
            //         menuItemCode:item.menuItemCode
            //     }}, '*')
            // window.close()
        },
        dealDetail(row){//处理
            this.dealId=row.id;
            this.dialogVisible=true;
        },
        handle() {//处理数据
            if (this.auditForm.opinion == '') {
                this.$message({
                message: '请填写处理意见',
                type: 'warning'
                });
                return;
            }
            jzwarnrecordHandle({id:this.dealId,opinion:this.auditForm.opinion,historyId:this.auditForm.historyId}).then(({data}) => {
                if (data.code == '1') {
                this.dialogVisible = false;
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$emit('refreshData', true);
                } else {
                this.$message({
                    message: '操作失败',
                    type: 'warning'
                });
                }
            })
        }
        
    },
    created(){
    }
}
</script>

<style lang="scss" scoped>
.complaints_head{
    display: flex;
    align-items: center;
    color: #ffffff;
    background: linear-gradient(270deg, rgba(255, 228, 0, 0.1) 0%, rgba(255, 197, 0, 0.1) 100%);
    border-radius: 2px 2px 0px 0px;
    height: 36px;
    img{
        margin-right: 9px;
    }
}
.complaints_cotent{
    padding: 12px 0 20px 16px;
    position: relative;
    .content-flex-row{
        display: flex;
        height: 30px;
        align-items: center;
        color: rgba(255, 255, 255, 0.7);
        span{
            display: inline-block;
        }
        span:nth-of-type(1){
            width:12px ;
        }
        span:nth-of-type(2){
            margin: 0 16px 0 5px;
            width: 58px;
        }
        span:nth-of-type(3){
            width: calc(100% - 100px);
            line-height: 20px;
        }
    }
    .tooltipItem{
        display: inline-block;
        overflow: hidden;
        text-overflow:ellipsis; 
        white-space: nowrap;
        width: calc(100% - 120px);
    }
    .content-title{
        width: calc(100% - 34px);
        font-size: 14px;
        font-weight: 550;
        font-family: PingFangSC-Medium, PingFang SC;
        color: rgba(255, 255, 255, 0.85);
        line-height: 20px;
        height: 40px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
        overflow: hidden;
    }
    .btnBox{
        text-align: center;
        margin-bottom: 4px;
        /deep/ .el-button--primary{
            padding: 8px 55px;
        }

    }
    .header_img{
        position: absolute;
        top: 28px;
        right: 12px;
    }
}
</style>